import { render, staticRenderFns } from "./HTMLEditor.vue?vue&type=template&id=60aa3940"
import script from "./HTMLEditor.vue?vue&type=script&lang=js"
export * from "./HTMLEditor.vue?vue&type=script&lang=js"
import style0 from "./HTMLEditor.vue?vue&type=style&index=0&id=60aa3940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports